<template>
  <div class="rightSide" :class="bottBox ? '' : 'rightclose'">
    <img
      @click="toggle"
      class="collImg"
      :class="bottBox ? 'collpase' : 'collclose'"
      :src="collImg"
    />
    <div class="sidebox"><slot></slot></div>
  </div>
</template>

<script>
export default {
  name: "RightSide",
  data() {
    return {
      bottBox: true,
      collImg: require("images/collclose.png")
    };
  },
  methods: {
    toggle() {
      this.bottBox = !this.bottBox;
      if (this.bottBox) {
        this.collImg = require("images/collclose.png");
      } else {
        this.collImg = require("images/collopen.png");
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~styl/largeScreen/RightSide'
@import '~styl/smallScreen/RightSide'
</style>
